<template>
 <div class="contact-us-wrap">
    <div class="top-wrap">
            <div class="text-wrap">
                <div class="title">联系我们</div>
                <img src="../assets/address.png" alt="" >
                <!-- <div class="sub-title">福建驰城通科技有限公司是行业领先的互联网应用服务商，专注于互联网创新模式软件开发，拥有强大的技术团队。集系统开发、小程序定制、APP定制、社区团购定制、高端网站定制开发为一体。为企业提供一站式信息化解决方案，助力企业信息化转型成功。</div> -->
            </div>
            <!-- <img src="../assets/banner_img.png" alt=""> -->
            <!-- <img src="../assets/banner_img.png" alt=""> -->
            <img src="../assets/banner/banner_img_icon_2.png" alt="">

        </div>
    <div class="item-wrap">
        <div class="item odd">
            <i class="iconfont icon-iconfontdizhi"></i>
            <div class="title">公司地址</div>
            <div class="sub-title">福州市闽侯县科技东路12号华建大厦1幢402室</div>
        </div>
        <div class="item even">
            <i class="iconfont icon-dianhua-xianxingyuankuang"></i>
            <div class="title">联系电话</div>
            <div class="sub-title">0591-83053703</div>
        </div>
        <div class="item odd">
            <i class="iconfont icon-icon_xinyong_xianxing_jijin-119"></i>
            <div class="title">联系邮箱</div>
            <div class="sub-title">chichengtong01@163.com</div>
        </div>
        <div class="item even">
            <i class="iconfont icon-weixin"></i>
            <div class="title">微信公众号</div>
            <div class="sub-title">驰城通科技</div>
        </div>
    </div>
    <div class="server-plan-wrap">
        <div class="title">服务计划</div>
        <div class="list-wrap">
            <div class="item">
                <div class="title">售前咨询</div>
                <div class="sub-title">专业的咨询师为用户系统的方案策划和咨询，包括如何选择产品功能和架构梳理，APP上架等资料准备，帮助用户快速上线运营</div>
            </div>
            <div class="item">
                <div class="title">售后服务</div>
                <div class="sub-title">客服专员为已购买专业版的客户提供的快速服务通道，解决客户在使用Ptaxi过程中遇到的相关问题，包括系统设置、页面编辑、应用管理、备案、APP上架和续费。</div>
            </div>
            <div class="item">
                <div class="title">尊享服务</div>
                <div class="sub-title">服务团队为有高级需求的企业客户提供的尊享无忧付费服务，为客户提供一站式的解决方案，包括方案策划、设计、制作、测试、上线、推广全程服务。</div>
            </div>

        </div>
    </div>
 </div>
</template>

<script>
export default {
  data () {
    return {
        items:[{img:'dizhi',title:'公司地址',subTitle:'福州市闽侯县科技东路12号华建大厦1幢402室'}]
    }
  },
  computed: {
  },
  mounted() {
  },
}

</script>
<style scoped lang="scss">
.contact-us-wrap{
    // padding-top: 40px;
    .top-wrap{
           height: 450px;
           background: #466dff;
           display: flex;
           align-items: center;
           justify-content: center;
           .text-wrap{
               width: 450px;
               // background: orange;
               margin-right: 50px;
               color: white;
               .title{
                   font-size: 24px;
                   margin-bottom: 20px;
               }
               .sub-title{
                   font-size: 16px;
               }
           }
       }
    .item-wrap{
        width: 90%;
        height: auto;
        margin: 40px auto;
        // background: orange;
        display: flex;
        justify-content: space-between;
        .odd{
            background: #ecfaf2;
        }
        .even{
            background: #f5f5f5;
        }
        .item{
            width: 22%;
            display: inline-block;
            text-align: center;
            padding: 40px 0px;
            // height: 200px;
            // border: 1px solid red;
            .iconfont {
                color: #04b24e;
                font-size: 40px;
            }
            .title{
                margin: 20px 0px 10px;
            }
        }
    }
    .server-plan-wrap{
        width: 90%;
        margin: 50px auto 10px;
        .title{
            text-align: center;
            font-size: 30px;
        }
        .list-wrap{
            margin-top: 30px;
            display: flex;
            justify-content: space-between;
            .item{
                width: 30%;
                .title{
                    text-align: left;
                    margin-bottom: 30px;
                    font-size: 18px;
                }
                .sub-title{
                    font-size: 14px;
                    color: #999;
                }
            }
        }
    }

}
</style>
